import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ConfigService} from '../config/config-service';
import { SessionService } from './session.service';

@Injectable()
export class CbtContadorService {
    private contador$ = new Subject<number>();
    private host_api: String;
    private _token: any;
    private config: ConfigService;

    constructor(
        private http: Http,
        private ss: SessionService,
    ){
        this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
    }

	actualizarContador(){
        this.getById(13).subscribe(
            res => this.contador$.next(res.valor)
        );
	}

	getContador$(): Observable<number>{
		return this.contador$.asObservable();
    }
    
    private getById(id) {
		let url = this.host_api + '/parametros/' + id;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.ss.getData('dbname'));
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/cbt-contador.service.ts